/**
 * 功能: 新增、修改数据的弹框组件
 */
<template lang="pug">
  el-dialog(title="专家说" :visible.sync="isShowQuote" :close-on-click-modal="false" :append-to-body="isChildDialog" @close="close")
    el-form.demo-addQuote(:model="quoteInfo" :rules="rules" ref="quoteRef" label-width="100px")
      el-row
        el-col(:span="11")
          el-form-item.fl(label="主题")
            el-input(v-model="quoteInfo.subject" placeholder="请输入主题" :size="GLOBAL.SIZE_OF_INPUTBOX")
          //- el-form-item.fl(label="状态" prop="status")
          //-   el-select(v-model="quoteInfo.status"  placeholder="状态" :size="GLOBAL.SIZE_OF_INPUTBOX")
          //-     el-option(v-for="item in STATUS" :label="item.label" :value="item.value" :key="item.value")
        el-col(:span="11")
            el-form-item.fl(label="上传头像")
              el-upload.avatar-uploader( :action="GLOBAL.uploadHost+ 'quote/upload'"  :headers="headers" :show-file-list="false" :on-success="success" accept="image/jpeg,image/png" :before-upload="beforeAvatarUpload" v-loading="loading")
                img( v-if="quoteInfo.avatar" :src="GLOBAL.OSS+quoteInfo.avatar" class="avatar" )
                i( v-else class="el-icon-plus avatar-uploader-icon")
      el-row
        el-col(:span="11")
          el-form-item.fl(label="专家编号" prop="expertId" )
            el-autocomplete(v-model="quoteInfo.expertId" :disabled="idDisable" :fetch-suggestions="autoCompleteId" @select="handleSelect" :size="GLOBAL.SIZE_OF_INPUTBOX" value-key="expertId" @blur="handleblur" :trigger-on-focus="false")

            //- el-input(v-model="quoteInfo.expertId" placeholder="请输入编号" :size="GLOBAL.SIZE_OF_INPUTBOX" @blur='autoMatchExpert')
        el-col(:span="11" )
          el-form-item.fl(label="专家姓名" prop="expertName" type='flex')
            el-input(v-model="quoteInfo.expertName" placeholder="请输入姓名" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="nameDisable")
            //- el-popover(placement="right"
            //-   title="相关专家说"
            //-   width="400"
            //-   trigger="hover" style='height:400px')
            //-   p(v-for='item,index in relativeContent') {{(index+1)+'、'+item}}
            //-   el-button(slot="reference" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled='showRelative') 相关专家说

      el-row
        //- el-col(:span="11")
        //-   el-form-item.fl(label="行业")
        //-     FrostIndustry(
        //-         v-model="quoteInfo.industryId" v-bind:name="quoteInfo.industry" v-on:change="quoteInfo.industry = $event" :size="GLOBAL.SIZE_OF_INPUTBOX")
        el-form-item.fl(label="")
          el-popover(placement="right"
            title="相关专家说"
            width="400"
            trigger="hover" style='height:400px')
            p(v-for='item,index in relativeContent') {{(index+1)+'、'+item}}
            el-button(slot="reference" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled='showRelative') 相关专家说

      el-row
        el-col(:span="11")
          el-form-item.fl(label="厂牌")
            brandSelect(v-model="quoteInfo.brand" :brandName="quoteInfo.brandName" @brandName="getbrandName")
        //- el-col(:span="11")
        //-   el-form-item.fl(label="来源")
        //-     el-input(v-model="quoteInfo.source" placeholder="请输入来源" :size="GLOBAL.SIZE_OF_INPUTBOX")
        el-col(:span="11")
          el-form-item.fl(label="公司职位")
            el-input(v-model="quoteInfo.company" placeholder="请输入公司名称+职位" :size="GLOBAL.SIZE_OF_INPUTBOX")
      el-row
        el-col(:span="22")
          el-form-item(label="内容" prop="content")
            el-input(v-model="quoteInfo.content" type="textarea" :rows="8" :size="GLOBAL.SIZE_OF_INPUTBOX" placeholder="请输入内容")
      el-row
        el-col(:span="11")
          el-form-item
            el-button(type="primary" @click="addQuote" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="quoteInfo.status > 0") 保存
            el-button(@click="isShowQuoteDialog" :size="GLOBAL.SIZE_OF_INPUTBOX") 取消

</template>
<script>
import brandSelect from '@/components/brandSelect'
import FrostIndustry from '@/components/industry'
import Quote from '@/apis/attachment'
import Enum from '@/apis/enum'
import passport from '@/javascripts/passport'

export default {
  props: {
    quoteInfo: { type: Object, default: () => { } },
    /* isChildDialog: 是否是嵌套的dialog */
    isChildDialog: {
      type: Boolean,
      default: false
    },
    brief: Object
  },
  components: { FrostIndustry, brandSelect },
  created () {
    this.STATUS = Enum.STATUS
  },
  data () {
    return {
      headers: passport.headers(),
      idDisable: false,
      nameDisable: false,
      loading: false,
      isShowQuote: false,
      rules: {
        expertId: [
          { required: true, message: '请输入专家编号', trigger: 'blur' }
        ],
        expertName: [
          { required: true, message: '请输入专家姓名', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      relativeContent: [],

      restaurant: [],
      showRelative: false

    }
  },

  methods: {
    // 获取厂牌数据
    getbrandName (brandName) {
      this.quoteInfo.brandName = brandName
    },
    // 添加专家说
    addQuote () {
      this.$refs.quoteRef.validate(valid => {
        if (valid) {
          this.$emit('saveQuote', this.quoteInfo, () => {
            this.isShowQuoteDialog()
          })
        }
      })
    },
    // 取消专家说对话框
    isShowQuoteDialog () {
      this.isShowQuote = !this.isShowQuote
      if (this.isShowQuote) {
        this.$nextTick(() => {
          this.$refs.quoteRef.clearValidate()
          if (this.quoteInfo._id) {
            this.showRelative = true
          } else {
            this.showRelative = false
            this.idDisable = false
            this.nameDisable = false
          }
        })
      } else {
        this.relativeContent = []
        this.$emit('getQuote')
      }
    },
    // 关闭弹框
    close () {
      this.relativeContent = []
      this.$emit('close')
    },
    // 上传头像图片验证
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 < 100
      this.loading = true
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        this.loading = false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 100KB!')
        this.loading = false
      }
      return isJPG && isLt2M
    },
    // 上传专家头像
    success (res) {
      this.loading = false
      this.quoteInfo.avatar = res.data
    },
    // 自动补全专家信息
    autoCompleteId (queryString, cb) {
      const ignore = ['未知', '无']
      if (ignore.indexOf(queryString) > -1) return []
      Quote.autoMatchQuote({ expertId: queryString }).then(res => {
        if (res.errCode === 0) {
          const map = new Map()
          const result = res.data.filter(item => !map.has(item.expertId) && map.set(item.expertId, 1))
          this.restaurant = result
          cb(result)
        }
      }).catch(err => {
        this.$message({
          type: 'error',
          message: '获取专家信息失败' + err
        })
      })
    },
    // 选择下拉框里的内容
    handleSelect (item) {
      this.relativeContent = []
      const keys = ['expertName', 'company', 'avatar', 'source']
      if (item) {
        for (const key of keys) {
          if (item[key]) this.$set(this.quoteInfo, key, item[key])
          else this.$set(this.quoteInfo, key, '')
        }
        Quote.allContent({ expertId: item.expertId }).then(res => {
          res.data.map(v => {
            v && this.relativeContent.push(v.slice(0, 20) + '……')
          })
        })
        this.nameDisable = true
      } else {
        for (const key of keys) {
          this.$set(this.quoteInfo, key, '')
        }
        this.nameDisable = false
      }
    },
    // 赋值选中的数据
    handleblur () {
      let timer = null
      if (this.restaurant.length === 0) {
        timer = setTimeout(() => {
          clearTimeout(timer)
          const single = this.restaurant.find(v => v.expertId === this.quoteInfo.expertId)
          this.handleSelect(single)
        }, 500)
      } else {
        const single = this.restaurant.find(v => v.expertId === this.quoteInfo.expertId)
        this.handleSelect(single)
      }
    },
    beforeDestroy () {
      this.$bus.$off('getBriefIndustry')
    }
  }
}
</script>
<style scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  line-height: 0;
  overflow: hidden;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: auto;
  display: block;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
<style>
.el-popover {
  height: 40vh;
  overflow: auto;
}
</style>
